import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { role: "document" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.42,7.96L15.24,2.14c.35-.35,.35-.92,0-1.27s-.92-.35-1.27,0l-5.82,5.82L2.33,.87c-.35-.35-.92-.35-1.27,0s-.35,.92,0,1.27L6.88,7.96,1.06,13.79c-.35,.35-.35,.92,0,1.27,.18,.18,.4,.26,.63,.26s.46-.09,.63-.26l5.82-5.82,5.82,5.82c.18,.18,.4,.26,.63,.26s.46-.09,.63-.26c.35-.35,.35-.92,0-1.27l-5.82-5.82Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { modal } from '@/components/main/modal'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  setup(__props) {

const view_height = ref(window.innerHeight)
const active = ref(false)
const visible = ref(false)
const component = () => { return modal.component }

// set modal state handlers
modal.on_activate = () => {
  active.value = true
  // window.addEventListener("scroll", on_scroll)
  window.addEventListener("resize", on_scroll)

  console.log(modal.props)
  setTimeout(() => { visible.value = true }, 50)
}
modal.on_deactivate = () => {
  visible.value = false
  // window.removeEventListener("scroll", on_scroll)
  window.removeEventListener("resize", on_scroll)
  setTimeout(() => { active.value = false }, 50)
}

// modal close func
const close = () => {
  modal.close()
}

const on_scroll = () => {
  view_height.value = window.innerHeight
}


return (_ctx: any,_cache: any) => {
  return (active.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["modal", {'active': visible.value}]),
        tabindex: "-1",
        role: "dialog",
        style: _normalizeStyle({height: view_height.value + 'px'})
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_unref(modal).props['required'])
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "close",
                onClick: close
              }, _hoisted_3))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(component())))
        ])
      ], 6))
    : _createCommentVNode("", true)
}
}

})